const SliderArrowIcon = ({ direct }) => {
  return direct ? (
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.65625 12.3115L2.34523 7.00047L7.65625 1.68945" stroke="currentColor" strokeWidth="2" />
    </svg>
  ) : (
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.34375 1.68851L6.65477 6.99953L1.34375 12.3105" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

export default SliderArrowIcon;
